<template>
  <CardGroups class="_my-sm-40 _my-md-60">
    <CardBox>
      <CardHeader>
        <BtnToggle collapse-target="accordion0" class="-plus">
          <h2 class="heading">撮影時のポイント</h2>
        </BtnToggle>
      </CardHeader>
      <CollapseItem id="accordion0" accordion="accordion" :visible="true">
        <CardBody>
          <div class="point-box _mb-md-30">
            <div class="point-img _mb-sm-30 _pr-md-20">
              <p class="txt01 _mb-md-30">
                <img
                  src="@/assets/images/icons/circle-orange.svg"
                  class="img-fluid _mr-md-20"
                  alt=""
                />よい例
              </p>
              <img
                src="@/assets/images/en/en018/img01.jpg"
                class="img-fluid"
                alt=""
              />
              <ListGroup class="-normal _mt-15">
                <ListItem class="-normal">文字がはっきり読める</ListItem>
                <ListItem class="-normal">書類全体が写っている</ListItem>
              </ListGroup>
            </div>
            <div class="point-img _pl-md-20">
              <p class="txt01 _mb-md-30">
                <img
                  src="@/assets/images/icons/close-gray.svg"
                  class="img-fluid _mr-md-20"
                  alt=""
                />悪い例
              </p>
              <img
                src="@/assets/images/en/en018/img02.jpg"
                class="img-fluid"
                alt=""
              />
              <ListGroup class="-normal _mt-15">
                <ListItem class="-normal">画像がぼやけている</ListItem>
                <ListItem class="-normal">写真が切れている</ListItem>
              </ListGroup>
            </div>
          </div>
          <ListGroup class="-note">
            <ListItem class="-note">画像はイメージになります。</ListItem>
            <ListItem class="-note"
              >画像に不備がある場合、お電話を差しあげることがございます。</ListItem
            >
          </ListGroup>
        </CardBody>
      </CollapseItem>
    </CardBox>
  </CardGroups>
</template>

<script>
import CollapseItem from "@/components/collapse/CollapseItem";
import CardBody from "@/components/card/CardBody";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import BtnToggle from "@/components/button/BtnToggle";

export default {
  name: "IncomePoint",
  components: {
    BtnToggle,
    CardHeader,
    CardBox,
    CardGroups,
    ListItem,
    ListGroup,
    CardBody,
    CollapseItem,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.point-box {
  display: flex;
  flex-wrap: wrap;
  > .point-img {
    width: 100%;
    @include mq-up(md) {
      width: 50%;
    }
    > .txt01 {
      width: 100%;
      display: flex;
      align-items: center;
      font-weight: bold;
      img {
        width: 20px;
        @include mq-up(md) {
          width: 30px;
        }
      }
    }
    img {
      width: 50%;
      @include mq-down(md) {
        /*width: calc(50% - 2px);*/
        width: 100%;
      }
      @include mq-up(md) {
        /*max-width: 287px;*/
        width: 100%;
      }
    }
  }
}
</style>
